/**
 * Generates a customer statement PDF (open invoices + payment history) using
 * @react-pdf/renderer, matching the pattern used for invoice/proposal PDFs.
 */
import React from 'react'
import { pdf } from '@react-pdf/renderer'
import { CustomerStatementPdf, type CustomerStatementProps } from '../components/CustomerStatementPdf'

export async function buildStatementPdfBlob(props: CustomerStatementProps): Promise<Blob> {
  const instance = pdf(React.createElement(CustomerStatementPdf, props) as any)
  return instance.toBlob()
}

export async function downloadStatementPdf(props: CustomerStatementProps, fileName: string): Promise<void> {
  const blob = await buildStatementPdfBlob(props)
  const url = URL.createObjectURL(blob)
  try {
    const link = document.createElement('a')
    link.href = url
    link.download = `${fileName}.pdf`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  } finally {
    setTimeout(() => URL.revokeObjectURL(url), 1000)
  }
}
